import React, { useMemo } from 'react';

import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  FinConElemSchVariableRate,
  getVarInterestByCiid,
} from 'services/clientInvoice';
import Title from 'components/Title';
import { useForm } from 'antd/lib/form/Form';
import { useQuery } from 'react-query';
import { toCurrency, toRate } from 'utils/utils';
import ModalControllerNV from 'components/ModalControllerNV';
import CiVarInterestRateDetailModal from './CiVarInterestRateModal';

type TabCiVarInterestProps = {
  ciid: number | undefined;
  currcode: string;
  type?: string;
};

const TabCiVarInterest = (props: TabCiVarInterestProps) => {
  const { ciid, currcode, type } = props;
  const fieldName = 'ciprefininterest';
  const [form] = useForm();
  const { data: varInterestList, isLoading } = useQuery(
    ['getVarInterestByCiid', ciid],
    () =>
      getVarInterestByCiid({ ciid: Number(ciid) }).then((res) => {
        return res.list || [];
      }),
    { enabled: !!ciid }
  );

  const columns = useMemo<DataGridColDef<FinConElemSchVariableRate>[]>(
    () => [
     
      {
        dataIndex: 'calcstartdate',
        width: '100px',
        render: (value, record, index) => {
          return (
            <ModalControllerNV
              modal={({ setVisible, visible }) => (
                <CiVarInterestRateDetailModal
                  visible={visible}
                  calcid={record.calcid}
                  onCancel={() => setVisible(false)}
                  currcode={currcode}
                />
              )}
              content={({ setVisible, visible }) => (
                <a
                  onClick={() => {
                    setVisible(true);
                  }}
                >
                  {value}
                </a>
              )}
            />
          );
        },
      },
      {
        dataIndex: 'calcenddate',
        width: '150px',
        render: (value, record, index) => {
          return (
            <ModalControllerNV
              modal={({ setVisible, visible }) => (
                <CiVarInterestRateDetailModal
                  visible={visible}
                  calcid={record.calcid}
                  onCancel={() => setVisible(false)}
                  currcode={currcode}
                />
              )}
              content={({ setVisible, visible }) => (
                <a
                  onClick={() => {
                    setVisible(true);
                  }}
                >
                  {value}
                </a>
              )}
            />
          );
        },
      },
      {
        dataIndex: 'nbcalcdays',
        width: '100px',
      },
      {
        dataIndex: 'rateformula',
        width: '100px',
      },
      // {
      //   dataIndex: 'calcdate',
      //   width: '100px',
      //   render: (value, record, index) => {
      //     return (
      //       <ModalControllerNV
      //         modal={({ setVisible, visible }) => (
      //           <PrefinInterestListModal
      //             visible={visible}
      //             list={record.ciPrefinInterestDetailList}
      //             onCancel={() => setVisible(false)}
      //             currcode={currcode}
      //           />
      //         )}
      //         content={({ setVisible, visible }) => (
      //           <a
      //             onClick={() => {
      //               setVisible(true);
      //             }}
      //           >
      //             {value}
      //           </a>
      //         )}
      //       />
      //     );
      //   },
      // },
      // {
      //   dataIndex: 'duedate',
      //   width: '100px',
      //   render: (value, record, index) => {
      //     return (
      //       <ModalControllerNV
      //         modal={({ setVisible, visible }) => (
      //           <PrefinInterestListModal
      //             visible={visible}
      //             list={record}
      //             onCancel={() => setVisible(false)}
      //             currcode={currcode}
      //           />
      //         )}
      //         content={({ setVisible, visible }) => (
      //           <a
      //             onClick={() => {
      //               setVisible(true);
      //             }}
      //           >
      //             {value}
      //           </a>
      //         )}
      //       />
      //     );
      //   },
      // },
      {
        dataIndex: 'ratevalue',
        width: '100px',
        render: (val, record) => toRate(val),
      },
      {
        dataIndex: 'amountbasis',
        width: '100px',
        render: (val, record) => toCurrency(val, currcode),
      },
      {
        dataIndex: 'interestcalcamount',
        width: '100px',
        render: (val, record) => toCurrency(val, currcode),
      },
    ],
    []
  );

  return (
    <div style={{ backgroundColor: '#f7f7f7', padding: 5 }}>
      <Title comcode="varInterestList" level={5}></Title>

      <DataGrid
        columns={columns}
        dataSource={varInterestList}
        rowKey="calid"
        scroll={{ x: 1200, y: 360 }}
        hideFilters
        isLoading={isLoading}
      />
    </div>
  );
};

export default TabCiVarInterest;
